import React, { useState } from "react";
import "./modalStyles.css";
import i18next from "i18next";
import { useSelector } from "react-redux";
import { Document, Page, pdfjs } from "react-pdf";
import pdfjsWorker from "react-pdf/node_modules/pdfjs-dist/build/pdf.worker.entry";

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
const touristSamplePDFGreek = `${process.env.PUBLIC_URL}/assets/pdf/genikoi_oroi_paroxis_ypiresion_kartokinitis_v19_updated.pdf`;
const samplePDFEnglish = `${process.env.PUBLIC_URL}/assets/pdf/${encodeURIComponent("Mobile Internet Prepaid terms_EN updated.pdf")}`;
const samplePDFGreek = `${process.env.PUBLIC_URL}/assets/pdf/${encodeURIComponent("Mobile Internet Prepaid terms_GR updated.pdf")}`;
const samplePDFPayTerms = `${process.env.PUBLIC_URL}/assets/pdf/${encodeURIComponent("Όροι Χρήσης της Υπηρεσίας Ανανέωση Υπόλοιπου Χρήσης_Updated.pdf")}`;

const Modal = ({ isOnPopUpInside, openTerms, setOpenTerms, onHide, open }) => {
	const [numPages, setNumPages] = useState(null);
	const isTourist = useSelector((state) =>
		Boolean(state?.BalanceReducer?.payloadAfterLogIn?.isTourist),
	);
	const currentLanguage = (
		sessionStorage.getItem("language") ||
		i18next.resolvedLanguage ||
		i18next.language ||
		"gr"
	).toLowerCase();
	const isGreekLanguage =
		currentLanguage.startsWith("gr") || currentLanguage.startsWith("el");

	const termsPdfFile = isOnPopUpInside
		? samplePDFPayTerms
		: isTourist
			? touristSamplePDFGreek
			: isGreekLanguage
				? samplePDFGreek
				: samplePDFEnglish;

	function onDocumentLoadSuccess({ numPages }) {
		setNumPages(numPages);
	}

	return (
		<div
			className={
				open || openTerms
					? "hover_bkgr_terms_container_prof popup_open"
					: "hover_bkgr_terms_container_prof"
			}
		>
			<div
				className="terms_container"
				style={isOnPopUpInside ? { height: "150%", width: "145%" } : null}
			>
				<div className="title">
					<div
						className="title_one"
						onClick={() => {
							if (open) {
								onHide();
							} else {
								setOpenTerms(false);
							}
						}}
					>
						✕
					</div>
				</div>
				<div className="terms_container_body">
					<Document
						file={termsPdfFile}
						options={{ workerSrc: "./pdf.worker.js" }}
						onLoadSuccess={onDocumentLoadSuccess}
					>
						{Array.from(new Array(numPages), (el, index) => (
							<Page
								wrap={false}
								key={`page_${index + 1}`}
								pageNumber={index + 1}
							/>
						))}
					</Document>
				</div>
			</div>
		</div>
	);
};

export default Modal;
